import Vue from "vue";
import VueRouter from "vue-router";
import Sites from "../views/sites/Sites.vue";
import Index from "../views/Index.vue";
import Login from "../views/Login.vue";
import Profile from "../views/Profile.vue";
import store from "../store";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Index",
    component: Index,
    meta: {
      title: "",
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "login",
    },
  },
  {
    path: "/sites",
    name: "Sites",
    component: Sites,
    meta: {
      loginRequired: true,
      title: "sites",
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      loginRequired: true,
      title: "profile",
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // permission check
  if (to.matched.some((record) => record.meta.loginRequired)) {
    store.dispatch("user/getUserInfo").then((user) => {
      console.log(user);
      if (user && user.uid) {
        next();
      } else {
        next({ path: "/login" });
      }
    });
  } else if (to.matched.some((record) => record.meta.adminRequired)) {
    store.state.user.getUserInfo().then((user) => {
      console.log(user);
      if (user && user.role === "admin") {
        next();
      } else {
        next({ path: "/" });
      }
    });
  }

  next();
});

export default router;
